<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="sanitizeHtml(candidate.additional_information)" />
</template>

<script>
import sanitizeHtml from 'sanitize-html'

export default {
  name: 'AdditionalInformationModalContent',
  props: {
    candidate: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    sanitizeHtml
  }
}
</script>
